export enum GtmItemListNameEnum {
    HPLastVisited = 'HP_last_visited',
    HPPilulkaSelects = 'HP_pilulka_selects',
    HPPreviouslyPurchased = 'HP_previously_purchased',
    HPLastBoughtRecommendedProducts = 'HP_last_bought_recommended_products',
    HPFavoriteProducts = 'HP_favorite_products',
    HPSaleAndDiscountsCarousel = 'HP_sale_and_discounts_carousel',
    HPHitOfTheWeek = 'HP_hit_of_the_week',
    HPStaticCarousel = 'HP_static_carousel_',
    HPOnePlusOneCarousel = 'HP_one_plus_one_carousel',
    HPTwoPlusOneCarousel = 'HP_two_plus_one_carousel',
    Catalogue = 'Catalogue',
    SearchResults = 'Search_results',
    ProductDetail = 'Product_detail',

    ProductDetailSubstitution = 'Product_detail_substitution',
    ProductDetailSubstitutionAutoNonAggressive = 'Product_detail_substitution_auto_non_aggressive',
    ProductDetailSubstitutionManualNonAggressive = 'Product_detail_substitution_manual_non_aggressive',
    ProductDetailSubstitutionAutoAggressive = 'Product_detail_substitution_auto_aggressive',
    ProductDetailSubstitutionManualAggressive = 'Product_detail_substitution_manual_aggressive',
    ProductDetailSubstitutionAutoAggressiveDecline = 'Product_detail_substitution_auto_aggressive_decline',
    ProductDetailSubstitutionManualAggressiveDecline = 'Product_detail_substitution_manual_aggressive_decline',

    ProductDetailDynamicBundle = 'Product_detail_dynamic_bundle',

    ProductDetailSimilarProducts = 'Product_detail_similar_products',
    ProductDetailRecommendationProducts = 'Product_detail_recommendation_products',
    ProductDetailCarousel = 'Product_detail_carousel_',

    Favorites = 'Favorites',
    Inspiration = 'Inspiration',
    // NavigationCartBox = 'Navigation_cart_box',
    // Header_navigation_product
    // CartTopCarousel = 'Cart_top_carousel',
    // CartBottomCarousel1 = 'Cart_bottom_carousel_1',
    // MicrositeTopCarousel = 'Microsite_top_carousel',
    MicrositeCatalogue = 'Microsite_catalogue',

    PrebasketMain = 'Prebasket_Main',
    PrebasketAddonSale = 'prebasket',
    PrebasketCustomAddonSaleCarousels = 'Prebasket_custom_addon_sale_carousels',
    PrebasketAddonSaleAreas = 'Prebasket_addon_sale_areas',

    OrderConfirmCarousel = 'Order_confirm_carousel',
}
